import * as yup from 'yup'
import { PartnerDriverDeletionReason } from 'src/constants/partnerDriver/enums'

const REASON_VALUES: string[] = Object.values(PartnerDriverDeletionReason)

// Not `oneOf`: Formik turns '' into undefined and yup 1.x `oneOf` skips undefined.
export const deleteContractorFormValidator = yup.object({
  reason: yup.string().test('reason', 'Choose a reason', (value) => {
    return REASON_VALUES.includes(value ?? '')
  }),
})
